export default {"src":"/_next/static/media/molar.66c4f0b5.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};